/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import { IDescriptorBody } from '../../../descriptor';
import PackageDataMessage, { IPackageDataMessage } from './packagedatamessage';

import ParserUtils, { MessageDataTypes } from './../parserutils';

export interface INumberBytesPacketDataMessage extends IPackageDataMessage {
	data: number;
	data1: Buffer;
}

export default class NumberBytesPacketDataMessage extends PackageDataMessage {
	public static readonly TYPE: number =
		/* #__PURE__ -- @preserve */ ( () => ParserUtils.getPacketType( MessageDataTypes.NUMBER, MessageDataTypes.BUFFER ) )();

	public static readonly DESCRIPTOR_NAME: string = 'NumberBytesPacketDataMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = /* #__PURE__ -- @preserve */ ( () => ( {
		fields: {
			data: {
				type: 'uint32',
				id: 1
			},
			data1: {
				type: 'bytes',
				id: 2
			}
		}
	} ) )();

	public constructor( public readonly data: number, public readonly data1: Buffer ) {
		super();
	}

	public toJSON(): INumberBytesPacketDataMessage {
		return {
			data: this.data,
			data1: this.data1
		};
	}

	public static fromJSON( data: INumberBytesPacketDataMessage ): NumberBytesPacketDataMessage {
		return new NumberBytesPacketDataMessage( data.data, data.data1 );
	}

	public static create( data: number, data1: Buffer ): NumberBytesPacketDataMessage {
		return new NumberBytesPacketDataMessage( data, data1 );
	}
}
